var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-member-events-list',{ref:"eventsList",on:{"event-edit":function($event){return _vm.editEvent($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }